import { render, staticRenderFns } from "./Jewel01.vue?vue&type=template&id=0859d45d&scoped=true&"
import script from "./Jewel01.vue?vue&type=script&lang=js&"
export * from "./Jewel01.vue?vue&type=script&lang=js&"
import style0 from "./Jewel01.vue?vue&type=style&index=0&id=0859d45d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0859d45d",
  null
  
)

export default component.exports